import {Badge} from '@sail/ui';
import {FormattedMessage} from 'react-intl';
import messages from 'src/utils/messages';

export const TestmodeBadge = () => {
  return (
    <Badge type="warning">
      <FormattedMessage {...messages.testmodeBadgeLabel} />{' '}
    </Badge>
  );
};
